import { useParams } from 'react-router-dom';

import AccountabilityDefinitionForm from './AccountabilityDefinitionForm';

export default function EditAccountabilityDefinitionPage() {
  const { accountabilityDefinitionId } = useParams<{
    accountabilityDefinitionId: string;
  }>();

  return <AccountabilityDefinitionForm definitionId={accountabilityDefinitionId} />;
}
